import React, { useState, useEffect } from 'react';
import Chart from 'chart.js/auto';
import Navbar from '../../../Shared/ManagerNavbar/Navbar'
import './Dashboard.css';
import "./../../../Layout/Collapse/Collapse.css";

const dashboardData = {
  kpis: [
    { name: "Total Contacts", value: "1,250", change: "+15%", color: "green" },
    { name: "Active Opportunities", value: "45", change: "+10%", color: "green" },
    { name: "Pipeline Value", value: "₹3,78,00,000", change: "+20%", color: "green" },
    { name: "Conversion Rate", value: "28%", change: "-2%", color: "red" },
    { name: "New Customers", value: "12", change: "+25%", color: "green" },
    { name: "Assigned Leads/Opps", value: "95%", change: "+5%", color: "green" },
    { name: "Unassigned Items", value: "25", change: "-10%", color: "green" },
  ],
  contactSources: [
    { label: "Email", value: 60, color: "#3B82F6" },
    { label: "Referral", value: 40, color: "#10B981" },
  ],
  assignmentDistribution: [
    //{ label: "Managers", value: 30, color: "#8B5CF6" },
    { label: "Associates", value: 65, color: "#F59E0B" },
    { label: "Unassigned", value: 5, color: "#EF4444" },
  ],
  followUpStatus: [
    { label: "Initial Contact", value: 70 },
    { label: "Pending Follow-Up", value: 20 },
    { label: "No Response", value: 10 },
  ],
  topContacts: [
    { name: "Naveen (ABC Factory)", source: "Email", activity: "Call on 09/05", followUp: "09/12 (Email)", product: "Safety Helmets", assignedTo: "Manager: Sarah Lee" },
    { name: "Venkat (XYZ Corp)", source: "Referral", activity: "Meeting Scheduled", followUp: "09/15 (Demo)", product: "Machinery Guards", assignedTo: "Associate: Tom Harris" },
    { name: "Raviteja (Industrial Ltd)", source: "Email", activity: "Qualification Call", followUp: "09/11 (Budget Check)", product: "Tool Kits", assignedTo: "Associate: Emma Wong" },
  ],
  funnelData: [
    { stage: "Total Contacts", value: 1250 },
    { stage: "Followed-Up", value: 1000 },
    { stage: "Qualified", value: 300 },
    { stage: "Opportunities", value: 150 },
  ],
  pipelineStages: [
    { stage: "Needs Assessment", count: 30, value: "₹1,26,00,000", probability: 40, assignments: { managers: 10, associates: 20 } },
    { stage: "Proposal", count: 10, value: "₹84,00,000", probability: 60, assignments: { managers: 4, associates: 6 } },
    { stage: "Quotation Sent", count: 3, value: "₹67,20,000", probability: 80, assignments: { managers: 1, associates: 2 } },
    { stage: "Negotiation", count: 2, value: "₹1,00,80,000", probability: 90, assignments: { managers: 2, associates: 0 } },
    { stage: "Closed Won", count: 12, value: "₹1,51,20,000", probability: 100, assignments: { managers: 5, associates: 7 } },
  ],
  quotations: [
    { name: "ABC Factory Order", date: "09/08/2025", amount: "₹21,00,000", status: "Accepted", product: "Machinery Guards", customer: "Yes", assignedTo: "Manager: Sarah Lee" },
    { name: "XYZ Corp Tools", date: "09/05/2025", amount: "₹12,60,000", status: "Pending", product: "Tool Kits", customer: "Pending", assignedTo: "Associate: Tom Harris" },
    { name: "Industrial Ltd Gear", date: "09/03/2025", amount: "₹8,40,000", status: "Rejected", product: "Safety Helmets", customer: "No", assignedTo: "Associate: Emma Wong" },
  ],
  performers: [
    { name: "Sharvani", role: "Manager", contacts: 200, closed: 7, revenue: "₹1,00,80,000", load: "High (15 opps)" },
    { name: "Maniteja", role: "Associate", contacts: 300, closed: 3, revenue: "₹33,60,000", load: "Medium (10 opps)" },
    { name: "Rajesh", role: "Associate", contacts: 250, closed: 2, revenue: "₹16,80,000", load: "Low (8 opps)" },
  ],
  leadConversion: [
    { label: "Leads Created", value: 2000, color: "#EF4444" },
    { label: "Leads Converted", value: 1600, percent: "80%", color: "#FBBF24" },
    { label: "Deals Created", value: 1440, percent: "90%", color: "#10B981" },
    { label: "Deals Won", value: 1080, percent: "75%", color: "#3B82F6" },
  ]
};

// Styles
const styles = `
.dashboard { padding: 32px; background-color: #f8f9fa; min-height: 100vh; font-family: 'Roboto', Arial, sans-serif; color: #333; }
.dashboard-header { font-size: 28px; font-weight: 700; margin-bottom: 32px; text-align: center; }
.section-header { font-size: 22px; font-weight: 600; margin: 32px 0 16px; border-bottom: 2px solid #e0e0e0; padding-bottom: 8px; }
.kpi-grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(250px, 1fr)); gap: 20px; margin-bottom: 32px; }
.kpi-card { background-color: white; padding: 20px; border-radius: 10px; box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1); text-align: center; transition: transform 0.2s; }
.kpi-card:hover { transform: translateY(-4px); }
.kpi-card h3 { font-size: 16px; font-weight: 600; color: #555; margin-bottom: 8px; }
.kpi-card p.value { font-size: 28px; font-weight: 700; color: #333; }
.kpi-card p.change { font-size: 14px; }
.chart-grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(300px, 1fr)); gap: 20px; margin-bottom: 32px; }
.chart-container { background-color: white; padding: 20px; border-radius: 10px; box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1); }
.chart-container h3 { font-size: 18px; font-weight: 600; margin-bottom: 12px; color: #333; }
.table-container { background-color: white; padding: 20px; border-radius: 10px; box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1); overflow-x: auto; margin-bottom: 32px; }
.table-container h3 { font-size: 18px; font-weight: 600; margin-bottom: 12px; color: #333; }
table { width: 100%; border-collapse: collapse; font-size: 14px; }
th, td { padding: 12px; text-align: left; border-bottom: 1px solid #e0e0e0; }
th { background-color: #f5f5f5; font-weight: 600; color: #333; }
tr:hover { background-color: #f9f9f9; }
@media (max-width: 768px) {
  .dashboard { padding: 16px; }
  .kpi-grid { grid-template-columns: 1fr; }
  .chart-grid { grid-template-columns: 1fr; }
  .dashboard-header { font-size: 24px; }
  .section-header { font-size: 20px; }
}
`;

const styleSheet = document.createElement("style");
styleSheet.textContent = styles;
document.head.appendChild(styleSheet);

// KPI Card Component
function KPICard({ title, value, change, color }) {
  return (
    <div className="kpi-card">
      <h3>{title}</h3>
      <p className="value">{value}</p>
      <p className="change" style={{ color }}>{change}</p>
    </div>
  );
}

// Lead Conversion Funnel Component
function LeadConversionFunnel({ data, title }) {
  return (
    <div className="chart-container">
      <h3>{title}</h3>
      <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
        {data.map((item, idx) => (
          <div key={idx} style={{ width: "100%" }}>
            <div
              style={{
                backgroundColor: item.color,
                width: `${(item.value / data[0].value) * 100}%`,
                padding: "8px",
                borderRadius: "6px",
                color: "white",
                fontWeight: "600",
                textAlign: "center",
              }}
            >
              {item.label}: {item.value} {item.percent ? `(${item.percent})` : ""}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

// PieChart Component
function PieChart({ data, title, canvasId }) {
  useEffect(() => {
    const ctx = document.getElementById(canvasId).getContext("2d");
    const chart = new Chart(ctx, {
      type: "pie",
      data: {
        labels: data.map(item => item.label),
        datasets: [{ data: data.map(item => item.value), backgroundColor: data.map(item => item.color) }],
      },
      options: { plugins: { legend: { position: "bottom", labels: { font: { size: 12 } } } }, responsive: true, maintainAspectRatio: false },
    });
    return () => chart.destroy();
  }, [data, canvasId]);

  return (
    <div className="chart-container">
      <h3>{title}</h3>
      <canvas id={canvasId} style={{ maxHeight: "250px" }}></canvas>
    </div>
  );
}

// BarChart Component
function BarChart({ data, title, canvasId }) {
  useEffect(() => {
    const ctx = document.getElementById(canvasId).getContext("2d");
    const chart = new Chart(ctx, {
      type: "bar",
      data: { labels: data.map(item => item.label), datasets: [{ label: "Status", data: data.map(item => item.value), backgroundColor: "#3B82F6" }] },
      options: { scales: { y: { beginAtZero: true } }, responsive: true, maintainAspectRatio: false },
    });
    return () => chart.destroy();
  }, [data, canvasId]);

  return (
    <div className="chart-container">
      <h3>{title}</h3>
      <canvas id={canvasId} style={{ maxHeight: "200px" }}></canvas>
    </div>
  );
}

// FunnelChart Component
function FunnelChart({ data, title, canvasId }) {
  useEffect(() => {
    const ctx = document.getElementById(canvasId).getContext("2d");
    const chart = new Chart(ctx, {
      type: "bar",
      data: { labels: data.map(item => item.stage), datasets: [{ label: "Count", data: data.map(item => item.value), backgroundColor: ["#3B82F6", "#10B981", "#F59E0B", "#8B5CF6"] }] },
      options: { indexAxis: "y", scales: { x: { beginAtZero: true } }, plugins: { legend: { display: false } }, responsive: true, maintainAspectRatio: false },
    });
    return () => chart.destroy();
  }, [data, canvasId]);

  return (
    <div className="chart-container">
      <h3>{title}</h3>
      <canvas id={canvasId} style={{ maxHeight: "200px" }}></canvas>
    </div>
  );
}

// Table Component
function Table({ data, title, columns }) {
  return (
    <div className="table-container">
      <h3>{title}</h3>
      <table>
        <thead><tr>{columns.map(col => <th key={col}>{col}</th>)}</tr></thead>
        <tbody>
          {data.map((row, idx) => (
            <tr key={idx}>
              {columns.map(col => <td key={col}>{row[col.toLowerCase().replace(/\s+/g, "")] || row[col.replace(/\s+/g, "")]}</td>)}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

// Pipeline Table Component
function PipelineTable({ data, title }) {
  return (
    <div className="table-container">
      <h3>{title}</h3>
      <table>
        <thead>
          <tr>
            <th>Stage</th>
            <th>Count</th>
            <th>Value</th>
            <th>Probability</th>
            <th>Assignments</th>
          </tr>
        </thead>
        <tbody>
          {data.map((row, idx) => (
            <tr key={idx}>
              <td>{row.stage}</td>
              <td>{row.count}</td>
              <td>{row.value}</td>
              <td>{row.probability}%</td>
              <td>{row.assignments.managers}M / {row.assignments.associates}A</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}



const Dashboard = () => {
    const [collapsed, setCollapsed] = React.useState(false);
  return (
    <div className="CollapseContainer">
      <Navbar onToggleSidebar={setCollapsed} />
      <div className={`Collapse ${collapsed ? "collapsed" : ""}`}>
        <div className="dashboard">
          <h1 className="dashboard-header">  Dashboard</h1>

          {/* KPIs */}
          <div className="kpi-grid">
            {dashboardData.kpis.map((kpi, idx) => (
              <KPICard key={idx} title={kpi.name} value={kpi.value} change={kpi.change} color={kpi.color} />
            ))}
          </div>

          <h2 className="section-header">Contacts Overview</h2>
          <div className="chart-grid">
            <PieChart data={dashboardData.contactSources} title="Contact Sources" canvasId="contactSources" />
            <PieChart data={dashboardData.assignmentDistribution} title="Assignment Distribution" canvasId="assignmentDistribution" />
            <BarChart data={dashboardData.followUpStatus} title="Follow-Up Status" canvasId="followUpStatus" />
          </div>

          <div className="chart-grid">
            <Table data={dashboardData.topContacts} title="Top Contacts by Activity" columns={["Name", "Source", "Activity", "Follow-Up", "Product", "Assigned To"]} />
            <FunnelChart data={dashboardData.funnelData} title="Qualification Pipeline" canvasId="funnelChart" />
          </div>

          <div className="chart-grid">
            <PipelineTable data={dashboardData.pipelineStages} title="Opportunities Pipeline Stages" />
            <Table data={dashboardData.quotations} title="Recent Quotations" columns={["Name", "Date", "Amount", "Status", "Product", "Customer", "Assigned To"]} />
          </div>

          <div className="chart-grid">
            <Table data={dashboardData.performers} title="Top Team Performers" columns={["Name", "Role", "Contacts", "Closed", "Revenue", "Load"]} />
            <LeadConversionFunnel title="Lead Conversion Analytics" data={dashboardData.leadConversion} />
          </div>
        </div>
    </div>
    </div>
  )
}

export default Dashboard
